import { render, staticRenderFns } from "./ContainerPartners.vue?vue&type=template&id=9bd7ff98&scoped=true"
import script from "./ContainerPartners.vue?vue&type=script&lang=js"
export * from "./ContainerPartners.vue?vue&type=script&lang=js"
import style0 from "./ContainerPartners.vue?vue&type=style&index=0&id=9bd7ff98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd7ff98",
  null
  
)

export default component.exports